module.exports = __webpack_public_path__ + "static/media/pager.70b39b11.svg";